import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';

const EmailVerificationGuard = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate('/signin');
        return;
      }

      await user.reload();
      setUser(user);
      
      // Check if email verification is required
      const isGoogleUser = user.providerData.some(p => p.providerId === 'google.com');
      
      if (!user.emailVerified && !isGoogleUser) {
        navigate('/verify-email');
        return;
      }
      
      setLoading(false);
    });

    return unsubscribe;
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#9a51a0]"></div>
      </div>
    );
  }

  return children;
};

export default EmailVerificationGuard;